"use strict";

(function (angular) {
	"use strict";
	angular.module('webutils')
		.directive('openMap', function () {
			return {
				scope: false,
				restrict: 'A',
				link: function (scope, element, attr) {
					element.on('click', function () {
						window.open("http://www.google.com/maps/place/" + attr.location)
					});
				}
			};
		});
})(angular);